import React from "react";
import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";

export const createIndFeedback = async (postData) => {
    try {
  return await post<ApiResponse<[]>>('/cleaner/feedback', postData).then((res)=> {
    if(res?.success===true){
        return res
    }
    else {
        return null
    }
  })
    }
    catch(e){

    }
};
